/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { message } from 'antd';
import { useCookies } from 'react-cookie';
import { JspreadLicense } from '../../../utils/constant';
import { COMMON, ifyouApi } from 'apis/config';
import { bubbleSetApi } from 'apis/platform/bubbleSetApis';
import jspreadsheet from 'jspreadsheet-pro';
import TableToolbar from 'components/table/TableToolbar';
import DefaultButton from 'components/button/DefaultButton';
import { useTranslation } from 'react-i18next';
/**
 * * 플랫폼 관리 - 말풍선 세트 - 말풍선 세트 구성 테이블
 */

let currentExcel = null;
let source_total = []; // 소스 총 모음. code,code_name
let source_talk = []; // 템플릿 대화 데이터
let source_feeling = []; // 템플릿 속마음 데이터
let source_whisper = []; // 템플릿 속삭임 데이터
let source_yell = []; // 템플릿 외침 데이터
let source_bubble = []; // 말풍선 이미지들 드롭다운 데이터
let source_monologue = []; // monologue 드롭다운 데이터
let source_speech = []; // speech 드롭다운 데이터

const EmoticonTable = (props) => {
  const { t } = useTranslation();
  const { id } = props;
  const [cookies] = useCookies();
  const { user_id, platform_auth } = cookies;
  const [datas, setDatas] = useState();

  const jspreadsheetRef = useRef();
  const scaleArray = ['-1', '0', '1'];

  // 6종 말풍선 필터 드롭다운
  const dropDownFilterBubble = (instance, cell, c, r, source) => {
    let temp = currentExcel.getValueFromCoords(1, r); // 템플릿 종류: talk, yell..
    console.log(temp);
    let filterSource = [];

    if (temp === 'talk') {
      filterSource = source_talk.map((v) => v.code_name);
    }
    if (temp === 'feeling') {
      filterSource = source_feeling.map((v) => v.code_name);
    }
    if (temp === 'whisper') {
      filterSource = source_whisper.map((v) => v.code_name);
    }
    if (temp === 'yell') {
      filterSource = source_yell.map((v) => v.code_name);
    }
    if (temp === 'monologue') {
      filterSource = source_monologue.map((v) => v.code_name);
    }
    if (temp === 'speech') {
      filterSource = source_speech.map((v) => v.code_name);
    }
    return filterSource;
  };

  /// 말풍선 관련 드롭다운 데이터 불러오기
  const fetchDropDownData = async (el) => {
    console.log('call fetch drop down data!');

    // talk(대화) 관련 말풍선 드롭다운
    const talkList = await ifyouApi.post(`${COMMON}`, {
      func: 'bubble_sprite',
      code: 'talk',
    });
    // feeling(속마음) 관련 말풍선 드롭다운
    const feelingList = await ifyouApi.post(`${COMMON}`, {
      func: 'bubble_sprite',
      code: 'feeling',
    });
    // whisper(속삭임) 관련 말풍선 드롭다운
    const whisperList = await ifyouApi.post(`${COMMON}`, {
      func: 'bubble_sprite',
      code: 'whisper',
    });
    // yell(외침) 관련 말풍선 드롭다운
    const yellList = await ifyouApi.post(`${COMMON}`, {
      func: 'bubble_sprite',
      code: 'yell',
    });
    // monologue(독백) 관련 말풍선 드롭다운
    const monologueList = await ifyouApi.post(`${COMMON}`, {
      func: 'bubble_sprite',
      code: 'monologue',
    });
    // speech(중요대사) 관련 말풍선 드롭다운
    const speechList = await ifyouApi.post(`${COMMON}`, {
      func: 'bubble_sprite',
      code: 'speech',
    });
    // talk 배열
    source_talk = talkList.data; //{code:1, code_name:"사각"}
    source_feeling = feelingList.data;
    source_whisper = whisperList.data;
    source_yell = yellList.data;
    source_monologue = monologueList.data;
    source_speech = speechList.data;

    // 각 데이터들을 필요한 배열에 담자
    source_talk.forEach((item) => {
      //말풍선 id 값을 변경하기 위해 코드값도 담는 배열
      source_total.push({ code: item.code, code_name: item.code_name });
      // 필터 드롭다운을 위한 배열 - 말풍선 이미지 이름만 들어간다.
      source_bubble.push(item.code_name);
    });
    source_feeling.forEach((item) => {
      source_total.push({ code: item.code, code_name: item.code_name });
      source_bubble.push(item.code_name);
    });
    source_whisper.forEach((item) => {
      source_total.push({ code: item.code, code_name: item.code_name });
      source_bubble.push(item.code_name);
    });
    source_yell.forEach((item) => {
      source_total.push({ code: item.code, code_name: item.code_name });
      source_bubble.push(item.code_name);
    });
    source_monologue.forEach((item) => {
      source_total.push({ code: item.code, code_name: item.code_name });
      source_bubble.push(item.code_name);
    });
    source_speech.forEach((item) => {
      source_total.push({ code: item.code, code_name: item.code_name });
      source_bubble.push(item.code_name);
    });
  };

  const jspreadOption = {
    license: JspreadLicense,
    data: [[]],
    columns: [
      {
        type: 'text',
        name: 'serial_no',
        title: 'No.',
        readOnly: true,
        width: '80px',
      },
      {
        type: 'text',
        name: 'template',
        title: t('bubbleID.table.columns.template'),
        readOnly: true,
        width: '80px',
        filter: true,
      },
      {
        type: 'text',
        name: 'size',
        title: t('bubbleID.table.columns.size'),
        readOnly: true,
        width: '80px',
      },
      {
        type: 'text',
        name: 'pos',
        title: t('bubbleID.table.columns.position'),
        readOnly: true,
        width: '80px',
      },
      {
        type: 'autocomplete',
        // type: 'text',
        name: 'bubble_sprite_name',
        title: t('bubbleID.table.columns.balloonImage'),
        width: '205px',
        filter: dropDownFilterBubble,
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'autocomplete',
        name: 'outline_sprite_name',
        title: t('bubbleID.table.columns.outlineImage'),
        width: '205px',
        filter: dropDownFilterBubble,
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        name: 'pos_x',
        title: t('bubbleID.table.columns.appearancePositionX'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        name: 'pos_y',
        title: t('bubbleID.table.columns.appearancePositionY'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        name: 'textarea_left',
        title: t('bubbleID.table.columns.marginLeft'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        name: 'textarea_right',
        title: t('bubbleID.table.columns.marginRight'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        name: 'textarea_top',
        title: t('bubbleID.table.columns.marginTop'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        name: 'textarea_bottom',
        title: t('bubbleID.table.columns.marginBottom'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        name: 'custom_size_x',
        title: t('bubbleID.table.columns.customWidth'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        name: 'custom_size_y',
        title: t('bubbleID.table.columns.customHeight'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'autocomplete',
        title: t('bubbleID.table.columns.ratioX'),
        name: 'scale_x',
        source: scaleArray,
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'autocomplete',
        title: t('bubbleID.table.columns.ratioY'),
        name: 'scale_y',
        source: scaleArray,
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'autocomplete',
        name: 'tail_sprite_name',
        title: t('bubbleID.table.columns.tailImage'),
        width: '205px',
        filter: dropDownFilterBubble,
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'autocomplete',
        name: 'tail_outline_sprite_name',
        title: t('bubbleID.table.columns.tailOutlineImage'),
        width: '205px',
        filter: dropDownFilterBubble,
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'autocomplete',
        name: 'tail_scale_x',
        title: t('bubbleID.table.columns.tailRatioX'),
        source: scaleArray,
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'autocomplete',
        name: 'tail_scale_y',
        title: t('bubbleID.table.columns.tailRatioY'),
        source: scaleArray,
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        name: 'tail_pos_x',
        title: t('bubbleID.table.columns.tailPositionX'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        name: 'tail_pos_y',
        title: t('bubbleID.table.columns.tailPositionY'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'hidden',
        name: 'reverse_tail_sprite_name',
        title: t('bubbleID.table.columns.reversedTailImage'),
        width: '205px',
      },
      {
        type: 'hidden',
        name: 'reverse_tail_outline_sprite_name',
        title: t('bubbleID.table.columns.reversedTailOutlineImage'),
        width: '205px',
      },
      {
        type: 'hidden',
        name: 'reverse_tail_scale_x',
        title: t('bubbleID.table.columns.reversedTailRatioX'),
        source: scaleArray,
        width: '80px',
      },
      {
        type: 'hidden',
        name: 'reverse_tail_scale_y',
        title: t('bubbleID.table.columns.reversedTailRatioY'),
        source: scaleArray,
        width: '80px',
      },
      {
        type: 'hidden',
        name: 'reverse_tail_pos_x',
        title: t('bubbleID.table.columns.reversedTailPositionX'),
        width: '80px',
      },
      {
        type: 'hidden',
        name: 'reverse_tail_pos_y',
        title: t('bubbleID.table.columns.reversedTailPositionY'),
        width: '80px',
      },
      {
        type: 'text',
        name: 'font_color',
        title: t('bubbleID.table.columns.textColor'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'text',
        name: 'fill_color',
        title: t('bubbleID.table.columns.interiorColor'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'text',
        name: 'outline_color',
        title: t('bubbleID.table.columns.outlineColor'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        name: 'emoticon_pos_x',
        title: t('bubbleID.table.columns.emoticonPositionX'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        name: 'emoticon_pos_y',
        title: t('bubbleID.table.columns.emoticonPositionY'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'autocomplete',
        name: 'emoticon_scale_x',
        title: t('bubbleID.table.columns.emoticonRatioX'),
        source: scaleArray,
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'autocomplete',
        name: 'emoticon_scale_y',
        title: t('bubbleID.table.columns.emoticonRatioY'),
        source: scaleArray,
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        name: 'emoticon_width',
        title: t('bubbleID.table.columns.emoticonWidth'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        name: 'emoticon_height',
        title: t('bubbleID.table.columns.emoticonHeight'),
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'autocomplete',
        name: 'tag_sprite_name',
        title: t('bubbleID.table.columns.tagName'),
        width: '205px',
        filter: dropDownFilterBubble,
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        title: t('bubbleID.table.columns.tagNamePositionX'),
        name: 'tag_pos_x',
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'number',
        title: t('bubbleID.table.columns.tagNamePositionY'),
        name: 'tag_pos_y',
        width: '80px',
        readOnly: platform_auth === 'select' && true,
      },
      {
        type: 'hidden',
        name: 'bubble_sprite_id',
        title: t('bubbleID.table.columns.balloonID'),
        width: '80px',
      },
      {
        type: 'hidden',
        name: 'tag_sprite_id',
        title: t('bubbleID.table.columns.tagID'),
        width: '80px',
      },
      {
        type: 'hidden',
        name: 'outline_sprite_id',
        title: t('bubbleID.table.columns.outlineID'),
        width: '80px',
      },
      {
        type: 'hidden',
        name: 'tail_sprite_id',
        title: t('bubbleID.table.columns.tailID'),
        width: '80px',
      },
      {
        type: 'hidden',
        name: 'reverse_tail_sprite_id',
        title: t('bubbleID.table.columns.reversedTailID'),
        width: '80px',
      },
      {
        type: 'hidden',
        name: 'tail_outline_sprite_id',
        title: t('bubbleID.table.columns.tailOutlineID'),
        width: '80px',
      },
      {
        type: 'hidden',
        name: 'reverse_tail_outline_sprite_id',
        title: t('bubbleID.table.columns.reversedTailOutlineID'),
        width: '80px',
      },
      {
        type: 'hidden',
        name: 'variation',
        title: t('bubbleID.table.columns.group'),
        readOnly: true,
        width: '80px',
      },
    ],
    allowExport: false,
    tableOverflow: true,
    tableWidth: '1500px',
    tableHeight: '780px',
    freezeNested: 1,
    // freezeColumns: 5,
    filters: true,
    nestedHeaders: [
      [
        {
          title: t('bubbleID.table.nestHeader.notEditable'),
          colspan: 4,
        },
        {
          title: t('bubbleID.table.nestHeader.defaultSetting'),
          colspan: 12,
        },
        {
          title: t('bubbleID.table.nestHeader.tailSetting'),
          colspan: 6,
        },
        // {
        //   title: '반전 말꼬리 설정',
        //   colspan: 6,
        // },
        {
          title: t('bubbleID.table.nestHeader.colorSetting'),
          colspan: 3,
        },
        {
          title: t('bubbleID.table.nestHeader.emoticonSetting'),
          colspan: 6,
        },
        {
          title: t('bubbleID.table.nestHeader.nameTagSetting'),
          colspan: 3,
        },
      ],
    ],

    text: {
      areYouSureToDeleteTheSelectedRows: '눌러도 삭제 안됨',
      areYouSureToDeleteTheSelectedColumns: '눌러도 삭제 안됨',
    },
    onchange: function (el, cell, x, y, newValue, oldValue) {
      //행 5:말풍선 이미지 6:외곽선 17:말꼬리이미지  18:말꼬리외과선이미지 23:반전말꼬리이미지  24:반전말꼬리외곽선이미지

      // console.log(y); //열
      // 말풍선 전체 소스 for문 돌려
      for (let i = 0; i < source_total.length; i++) {
        // console.log(x); // 열
        // console.log(newValue);
        // 5번 열 - 말풍선
        if (x === '4' || x === 4) {
          if (source_total[i].code_name === newValue) {
            // currentExcel.options.data[y][36] = source_total[i].code;
            currentExcel.options.json[y]['bubble_sprite_id'] =
              source_total[i].code;
            // console.log(currentExcel.options.data[y][36]);
            // console.log(source_total[i].code);
            // setSpriteID(source_total[i].code);
          }
          if (newValue === '' || newValue === null) {
            currentExcel.options.json[y]['bubble_sprite_id'] = -1;
          }
          // 6번 열 - 외곽선
        } else if (x === '5' || x === 5) {
          if (source_total[i].code_name === newValue) {
            currentExcel.options.json[y]['outline_sprite_id'] =
              source_total[i].code;
            // console.log(currentExcel.options.json[y][37]);
          }
          if (newValue === '' || newValue === null) {
            currentExcel.options.json[y]['outline_sprite_id'] = -1;
          }
          // 17번 열 - 말꼬리
        } else if (x === '16' || x === 16) {
          if (source_total[i].code_name === newValue) {
            currentExcel.options.json[y]['tail_sprite_id'] =
              source_total[i].code;
            // console.log(currentExcel.options.json[y][38]);
          }
          if (newValue === '' || newValue === null) {
            currentExcel.options.json[y]['tail_sprite_id'] = -1;
          }
          // 18번 열 - 말꼬리 외곽선
        } else if (x === '17' || x === 17) {
          if (source_total[i].code_name === newValue) {
            currentExcel.options.json[y]['tail_outline_sprite_id'] =
              source_total[i].code;
            // console.log(currentExcel.options.json[y][40]);
          }
          if (newValue === '' || newValue === null) {
            currentExcel.options.json[y]['tail_outline_sprite_id'] = -1;
          }
          // 23번 열 - 반전 말꼬리
        } else if (x === '22' || x === 22) {
          if (source_total[i].code_name === newValue) {
            currentExcel.options.json[y]['reverse_tail_sprite_id'] =
              source_total[i].code;
            // console.log(currentExcel.options.json[y][39]);
          }
          if (newValue === '' || newValue === null) {
            currentExcel.options.json[y]['reverse_tail_sprite_id'] = -1;
          }
          // 24번 열 - 반전 말꼬리 외곽선
        } else if (x === '23' || x === 23) {
          if (source_total[i].code_name === newValue) {
            currentExcel.options.json[y]['reverse_tail_outline_sprite_id'] =
              source_total[i].code;
            // console.log(currentExcel.options.json[y][41]);
          }
          if (newValue === '' || newValue === null) {
            currentExcel.options.json[y]['reverse_tail_outline_sprite_id'] = -1;
          }
          //38번 열 - 태그 네임텍
        } else if (x === '38' || x === 38) {
          // console.log('태그 네임하고 있지');
          // console.log(source_total[i].code);
          // console.log(newValue);
          if (source_total[i].code_name === newValue) {
            currentExcel.options.json[y]['tag_sprite_id'] =
              source_total[i].code;
          }
          if (newValue === '' || newValue === null) {
            currentExcel.options.json[y]['tag_sprite_id'] = -1;
          }
        }
      }
    },

    contextMenu: function (obj, x, y, e) {
      return;
    },
    onbeforedeletecolumn: function (el, columnNumber, numOfColumns) {
      return false;
    },
    onbeforedeleterow: function (el, rowNumber, numOfRows) {
      return false;
    },
  };

  // 서버에서 데이터 불러오기
  const fetchData = async (excel) => {
    const res = await bubbleSetApi.detailRead(id, 'emoticon');

    // set 데이터 불러오기
    setDatas(res);
    excel.options.columns[4].source = source_bubble; // 말풍선 이미지
    excel.options.columns[5].source = source_bubble; // 외곽선 이미지
    excel.options.columns[16].source = source_bubble; // 말꼬리 이미지
    excel.options.columns[17].source = source_bubble; // 말꼬리 외곽선 이미지
    excel.options.columns[37].source = source_bubble; // 태그 네임 이미지
    excel.setData(res);

    if (res.length === 0) {
      excel.setData([[]]);
    } else {
      excel.setData(res);
    }
  };

  // 데이터 서버 전송!
  const handleSubmit = async (data) => {
    const res = await bubbleSetApi.detailUpdate(id, datas);
    if (res !== false) {
      message.success('이모티콘 말풍선 세트가 수정되었습니다.');
    } else {
      return false;
    }
  };

  useEffect(() => {
    fetchDropDownData();
    currentExcel = jspreadsheet(jspreadsheetRef.current, jspreadOption);
    setDatas(currentExcel);
    fetchData(currentExcel);
  }, []);
  return (
    <StyledLayout>
      <TableToolbar>
        <div></div>
        <DefaultButton
          onClick={handleSubmit}
          disabled={JSON.parse(cookies.platformAuth)}
        >
          서버 전송
        </DefaultButton>
      </TableToolbar>
      {/* 엑셀 데이터 출력 */}
      <div ref={jspreadsheetRef} className='table_color' />
    </StyledLayout>
  );
};

export default EmoticonTable;
const StyledLayout = styled.div`
  width: fit-content;
  // margin-top: -10px;
  // height: 90vh;
  // min-height: 90vh;
  overflow: auto;
  .jexcel {
    // border-top: unset;
    // border-left: unset;
  }
  .jexcel_container {
    max-width: 98vw;
  }
`;

const HeaderContainer = styled.div`
  // background-color: blue;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-bottom: 15px;
`;
